import { Routes } from '@angular/router';
import { accountRoutes } from './routes/accounts.routes';
import { betaRoutes } from './routes/beta.routes';
import { claimProfileRoutes } from './routes/claim-profile.routes';
import { locationRoutes } from './routes/location.routes';
import { printAssetsRoutes } from './routes/print-assets.routes';
import { profileRoutes } from './routes/profile.routes';
import { propertyReportRoutes } from './routes/property-reports.routes';
import { reviewConversionRoutes } from './routes/review-conversion.routes';
import { writeReviewRoutes } from './routes/write-reviews.routes';

export const routes: Routes = [
  ...betaRoutes,
  {
    path: '',
    loadComponent: () => import('@rma/public/site/home'),
    pathMatch: 'full',
    data: {
      showMarketingNav: true,
    },
  },
  {
    path: 'sitemap',
    loadChildren: () => import('@rma/public/site/sitemap'),
    data: {
      title: 'Sitemap',
    },
  },
  {
    path: 'search',
    loadComponent: () => import('@rma/public/search/nlp-search'),
    data: {
      title: 'Search',
    },
  },
  {
    path: 'blog',
    loadChildren: () => import('@rma/public/site/blog'),
    data: {
      title: 'Blog',
    },
  },
  {
    path: 'tracked-properties',
    loadChildren: () => import('@rma/public/campaigns/track-campaign'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/public/site/static-documents'),
  },
  {
    path: 'mls/licensing',
    loadComponent: () => import('@rma/public/site/licensing'),
  },

  ...accountRoutes,
  ...claimProfileRoutes,
  ...locationRoutes,
  ...printAssetsRoutes,
  ...profileRoutes,
  ...propertyReportRoutes,
  ...reviewConversionRoutes,
  ...writeReviewRoutes,
  {
    path: '',
    loadChildren: () => import('@rma/public/generic/fallback-pages'),
  },
];
